import { Body } from "./Body";
import { Container } from "./Container";
import { Overlay } from "./Overlay";

export const Modal = {
  Body,
  Container,
  Overlay,
};
